import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Filter Variant"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-filter-variant',
    templateUrl: './icon-filter-variant.component.html',
    styleUrls: ['./icon-filter-variant.component.scss'],
    standalone: false
})
export class IconFilterVariantComponent  {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
